import { format, parseISO } from 'date-fns'


export default function formatDate(dateString) {
  const date = parseISO(dateString);

  const formattedDate = format(date, 'yyyy-MM-dd');
  return formattedDate;
}
